class SizeChartFitSwiper extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('.swiper');
    if (!container || this.swiper) return;

    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', () => this.connectedCallback(), { once: true });
      return;
    }

    this.swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: this.querySelector('.size-chart-fit__scrollbar'),
        draggable: true,
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('size-chart-fit-swiper')) {
  customElements.define('size-chart-fit-swiper', SizeChartFitSwiper);
}
